'use client';

import React, { useState, useEffect } from 'react';
import { PaperPlaneAnimation } from './PaperPlaneAnimation';
import { useTranslation } from 'react-i18next';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  message = 'Processing your submission...'
}) => {
  const { t } = useTranslation();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return null;
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 max-w-md w-full text-center">
        <PaperPlaneAnimation className="mx-auto mb-4" />
        <h3 className="text-xl font-bold mb-2">{t('components.loadingOverlay.title')}</h3>
        <p className="text-gray-600 mb-4">{message}</p>
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500"></div>
        </div>
      </div>
    </div>
  );
};

export { LoadingOverlay };